module.exports = __webpack_public_path__ + "static/img/victim-teens-3.c2a99618.png";